/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const DeleteIncidentRecordFile = zod.object({
  "id": zod.string().uuid().optional(),
  "incidentRecordId": zod.string().uuid().optional()
});

export type DeleteIncidentRecordFile = zod.input<typeof DeleteIncidentRecordFile>;
export type DeleteIncidentRecordFileOutput = zod.output<typeof DeleteIncidentRecordFile>;
